import axios from 'axios';

export const apiGetRenewalDiscount = (payload) => axios.post(`/api/discounts/renewal`, payload);
export const apiGetExtensionDiscount = (payload) => axios.post(`/api/discounts/extension`, payload);
export const apiGetPreapprovedCreditDiscount = (payload) => axios.post(`/api/discounts/preapprovedCredit`, payload);
export const apiGetMembershipRenewalDiscount = (payload) => axios.post(`/api/discounts/membershipRenewal`, payload);
export const apiGetEventDiscount = (payload) => axios.post(`/api/discounts/event`, payload);
export const apiGetModuleDiscount = (payload) => axios.post(`/api/discounts/module`, payload);
